<template>
    <referral-member-list
        :title="$t('text.MySubordinates')"
        :description="$t('text.subordinatesDesc')"
        api-url="/api/m/referral/subordinates"
    />
</template>

<script>
import ReferralMemberList from '@/components/computer/ReferralMemberList.vue'

export default {
    components: {
        ReferralMemberList,
    },
}
</script>
